import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { CompanyContextService } from '../tenant/company-context.service';
import { readCompanyKeyFromPathFromRoot } from '../routing/company-route.util';

/**
 * Área «dados da empresa» / preferências: só **Admin** (`canAccessCompanyWorkspaceMenu`).
 */
export const companyAdminGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const companyContext = inject(CompanyContextService);
  const router = inject(Router);
  if (!auth.isAuthenticated()) {
    return router.createUrlTree(['/auth/login']);
  }
  if (companyContext.canAccessCompanyWorkspaceMenu()) {
    return true;
  }
  const key = readCompanyKeyFromPathFromRoot(route);
  if (key) {
    return router.createUrlTree(['/c', key, 'dashboard']);
  }
  return router.createUrlTree(['/auth/login']);
};
